import styled from 'styled-components';
import { Badge, FlexCrate, Spacer, Text } from '@perch-labs/shrike';
import { Container, List, LegacyListItem } from 'styles';

export const StyledSpacer = styled(Spacer)`
  padding: 16px 0;
`;

export const StyledList = styled(List)`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 0;
`;

export const StyledListItem = styled(LegacyListItem)`
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 0;
  padding-top: 0;
`;

export const StyledContainer = styled(Container).attrs({
  flex: true,
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  width: '100%',
})``;

export const StyledHeading = styled(Text).attrs<StyleProps>({
  textStyle: 'heading400',
})``;

export const StyledText = styled(Text).attrs<StyleProps>({
  textStyle: 'paragraph400',
})<{ lineThrough?: boolean }>`
  ${props => props.lineThrough && `text-decoration: line-through;`}
`;

export const StyledSecondaryText = styled(Text).attrs<StyleProps>({
  color: 'secondary',
  textStyle: 'paragraph400',
})``;

export const StyledSupportingText = styled(Text).attrs<StyleProps>({
  textStyle: 'paragraph400',
})``;

export const StyledTooltipContainer = styled(FlexCrate).attrs({
  alignItems: 'center',
  gap: '8px',
})`
  line-height: 0;
`;

export const SecondaryBadge = styled(Badge)`
  color: ${props => props.theme.colors.content.secondary};
  border: 1px solid ${props => props.theme.colors.content.secondary};
  background: transparent;
`;
